// extracted by mini-css-extract-plugin
module.exports = {"d2xZ4":"Z4_d2xZ4__kNTdy"};